import { useMemo } from 'react';
import { Button, mergeClasses } from '@fluentui/react-components';
import { useCartAddButtonStyles } from './CartAddButton.styles';
import { ICartAddButtonProps } from './CartAddButton.types';

const CartAddButton = (props: ICartAddButtonProps) => {
    const { text, onClick, className } = props;
    const styles = useCartAddButtonStyles();

    const classes = useMemo(
        () => mergeClasses(styles.root, className !== undefined && className),
        [styles.root, className]
    );

    return (
        <Button className={classes} onClick={onClick}>
            {text}
        </Button>
    );
};

export default CartAddButton;
